import Component from "vue-class-component";
import Vue from "vue";
import {EducationalInstitution, factory, QualificationModel, QualificationsClient, ResultError} from "@/api-client";
import {Prop} from "vue-property-decorator";
import {Location} from "vue-router";

@Component
export class QualificationAddBase<T extends QualificationModel> extends Vue {
    @Prop({ required: true })
    seafarerId!: string;

    @Prop({default: null})
    returnRoute!: Location | null;

    async submit(model: T): Promise<void> {
        model.seafarerId = this.seafarerId;
        return await new QualificationsClient()
            .addQualification(model)
            .then(async result => {
                const route = (this.returnRoute ? this.returnRoute : {name: "seafarer-qualifications"}) as Location;

                const params = route.params || {};
                params.addedItemId = result;
                route.params = params;

                await this.$router.replace(route);
            });
    }
}